import axios from "axios";
import { User } from "../../models/User";
import { get_site_auth_header } from "../auth/module";
import { BACKEND_SERVER } from "../common/env";


interface UserListResponse {
    results: UserResponse[],
    total_count: number
}

interface UserResponse {
    id:        number,
	username:  string,
	email:     string,
	created_at: number,
	updated_at: number,
}

interface UserListRequest {
    search_text: string,
    page_number: number,
    page_size: number
}
// userRoutes.HandleFunc("/", CreateUser).Methods("POST")
// 	userRoutes.HandleFunc("/{id:[0-9]+}", getUser).Methods("GET")
// 	userRoutes.HandleFunc("/", updateUser).Methods("PUT")
// 	userRoutes.HandleFunc("/{id:[0-9]+}", DeleteUser).Methods("DELETE")
// 	userRoutes.HandleFunc("/", listUsers).Methods("GET")

export async function list_users(search_text: string, page_number: number, page_size: number): Promise<UserListResponse> {
    try {
        const loc_headers = get_site_auth_header()

        const loc_request = {
           search_text: search_text,
           page_number: page_number,
           page_size: page_size 
        } as UserListRequest

        const users_response = await fetch(BACKEND_SERVER + '/users/list',
            {
                headers: {
                    ...loc_headers,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "POST"
            }
        )
    
        let loc_repsonse_json = await users_response.json()
        let loc_results = loc_repsonse_json.map((user: UserResponse) => {
            return user
        })

        return {
            results: loc_results,
            total_count: parseInt(users_response.headers.get('Total-Count') ?? "0")
        } as UserListResponse


    } catch (e) {
        //TODO add proper tracing
        console.log(e)
    }

    return {
        results:[], 
        total_count: 0
    } as UserListResponse
}

export async function update_user(id: number, username: string, email: string): Promise<UserResponse|null> {
    try {
        const loc_headers = get_site_auth_header()

        const loc_request = {
           id: id,
           username: username,
           email: email 
        } as UserResponse

        const user_response = await fetch(BACKEND_SERVER + '/users',
            {
                headers: {
                    ...loc_headers,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "POST"
            }
        )
        
        if (user_response.status !== 200) {
            console.error(user_response)
        } else {
            let loc_repsonse_json = await user_response.json() as UserResponse
            return loc_repsonse_json
        }


    } catch (e) {
        //TODO add proper tracing
        console.log(e)
    }

    return null
}

export async function delete_user(user: UserResponse): Promise<boolean> {
    try {
        const loc_headers = get_site_auth_header()

        const user_response = await fetch(BACKEND_SERVER + '/users/' + user.id,
            {
                headers: {
                    ...loc_headers,
                },
                method: "DELETE"
            }
        )
        
        if (user_response.status !== 200) {
            console.error(user_response)
        } else {
            return true
        }


    } catch (e) {
        //TODO add proper tracing
        console.log(e)
    }

    return false
}

interface ChangePasswordRequest {
    old_password: string,
    new_password: string
}

interface ChangePasswordResponse {
    message: string,
    success: boolean
}

export async function user_change_password(old_password: string, new_password: string): Promise<boolean|string> {
    try {
        const loc_headers = get_site_auth_header()

        const loc_request = {
           old_password: old_password,
           new_password: new_password 
        } as ChangePasswordRequest

        const user_response = await fetch(BACKEND_SERVER + '/users/change-password',
            {
                headers: {
                    ...loc_headers,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "POST"
            }
        )
        
        if (user_response.status !== 200) {
            console.error(user_response)
            return await user_response.text()
        } else {
            let loc_repsonse_json = await user_response.json() as ChangePasswordResponse
            if (loc_repsonse_json.success) {
                return true
            } else {
                return loc_repsonse_json.message
            }
        }

    } catch (e) {
        //TODO add proper tracing
        console.log(e)
        return "Unknown server error"
    }
}


interface CreateRegistrationTokenRequest {
    user_id: number
}

interface CreateRegistrationTokenResponse {
    token: string
}

export async function create_registration_token(user_id: number|null): Promise<string|null> {
    try {
        const loc_headers = get_site_auth_header()

        const loc_request = {
           user_id: user_id ?? -1,
        } as CreateRegistrationTokenRequest

        const user_response = await fetch(BACKEND_SERVER + '/users/create-registration-token',
            {
                headers: {
                    ...loc_headers,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "POST"
            }
        )
        
        if (user_response.status !== 200) {
            console.error(user_response)
        } else {
            let loc_repsonse_json = await user_response.json() as CreateRegistrationTokenResponse
            return loc_repsonse_json.token
        }
    } catch (e) {
        //TODO add proper tracing
        console.log(e)
    }

    return null
}